import axios from "axios";

const api = axios.create({
	baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`
});

export default api;
